import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader } from "./shared";

export default function NewsletterTab() {
    const [items, setItems] = useState([]);
    const refresh = () => api.get("/newsletter/subscribers").then((r) => setItems(r.data));
    useEffect(() => { refresh(); }, []);
    const remove = async (id) => {
        if (!window.confirm("Remove subscriber?")) return;
        await api.delete(`/newsletter/subscribers/${id}`); refresh(); toast.success("Removed");
    };
    const exportCsv = () => {
        const header = "email,name,source,status,created_at\n";
        const lines = items.map((s) => `${s.email},${(s.name || "").replace(/,/g, " ")},${s.source},${s.status},${s.created_at}`).join("\n");
        const blob = new Blob([header + lines], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = "subscribers.csv"; a.click();
        URL.revokeObjectURL(url);
    };
    return (
        <div data-testid="admin-newsletter">
            <PageHeader
                eyebrow="Admin · Newsletter"
                title="Subscribers."
                action={<button onClick={exportCsv} data-testid="newsletter-export" className="px-5 py-3 border border-espresso/30 text-xs uppercase tracking-widest2 font-semibold hover:bg-bone2">Export CSV</button>}
            />
            <div className="border border-espresso/15">
                <table className="w-full text-sm">
                    <thead className="text-left text-xs uppercase tracking-widest2 text-espresso bg-bone2/50">
                        <tr>
                            <th className="px-4 py-3">Email</th>
                            <th className="px-4 py-3">Name</th>
                            <th className="px-4 py-3">Source</th>
                            <th className="px-4 py-3">Status</th>
                            <th className="px-4 py-3">Joined</th>
                            <th className="px-4 py-3" />
                        </tr>
                    </thead>
                    <tbody>
                        {items.length === 0 && <tr><td colSpan={6} className="px-4 py-12 text-center text-muted2">No subscribers yet.</td></tr>}
                        {items.map((s) => (
                            <tr key={s.id} className="border-t border-espresso/10" data-testid={`subscriber-${s.id}`}>
                                <td className="px-4 py-4 font-medium">{s.email}</td>
                                <td className="px-4 py-4 text-muted2">{s.name || "—"}</td>
                                <td className="px-4 py-4 text-muted2">{s.source}</td>
                                <td className="px-4 py-4"><span className={`px-2 py-1 text-[10px] uppercase tracking-widest2 ${s.status === "subscribed" ? "bg-forest/10 text-forest" : "bg-espresso/15 text-espresso"}`}>{s.status}</span></td>
                                <td className="px-4 py-4 text-muted2 text-xs">{s.created_at?.slice(0, 10)}</td>
                                <td className="px-4 py-4 text-right"><button onClick={() => remove(s.id)} data-testid={`subscriber-delete-${s.id}`} className="text-xs uppercase tracking-widest2 text-terracotta hover:text-forest">Remove</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
